export const APP_NAME = "Timata Dispatch";

// build control
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const IS_STAGING = true; // false on the live

export const FREIGHTWAY_TOKEN =
  "Basic MTh1azV1bDF2MjZjcGx0ZmExNTJ0aGxvc2c6MWNrMXBwNmIzcTR0MmU2dmc5cXE3bWkwbmN2c2tvZ2xjaDdjOW5xZm5mbmFiZzdtOWFydQ==";

export const SERVER_URL = IS_DEVELOPMENT
  ? "http://127.0.0.1:5000/"
  : IS_STAGING
  ? "https://s1.timata.nz/"
  : "https://app.timata.nz/";

// export const SERVER_URL = "https://app.timata.nz";

export const DELIVERY_KEY = IS_DEVELOPMENT || IS_STAGING
  ? "https://customer-integration.ep-sandbox.freightways.co.nz"
  : "https://customer-integration.ep-prod.freightways.co.nz";

export const FREIGHTWAYS_AUTH = IS_DEVELOPMENT
  ? "https://auth.ep-sandbox.freightways.co.nz"
  : "https://auth.ep-prod.freightways.co.nz";

export const DEFAULT_MAX_WIDTH = "lg";

export const DEFAULT_DRAWER_WIDTH = 300;
export const DEFAULT_ELEVATION = 4;
export const DEFAULT_BOXES = 10;
export const COUNT_PER_PAGE = 10;

export const ADDRESS_RIGHT = {
  BASE_URL: "https://www.addressright.co.nz",
  API_KEY: "333093_Q5wdTu6YcsWhyRTu",
};

export const AWS_API = {
  AWS_ACCESS_KEY_ID: `AKIA4GGWYOEX32X3Q2XK`,
  AWS_SECRET_ACCESS_KEY: `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`,
  AWS_DEFAULT_REGION: `ap-southeast-2`,
  AWS_BUCKET_NAME: `pie-club`,
};
